import axios from 'axios'
import store from '../store'

const createAxiosAuthInterceptor = () => {
    const axiosInstance = axios.create({
        headers: {
            'Content-Type': 'application/json',
        },
        withCredentials: true,
    })

    axiosInstance.interceptors.request.use(config => {
        if (store) {
            const { auth0 } = store.getState()
            const {authTypeReducer, authTokenReducer} = auth0

            if (authTypeReducer.isAuth0Enabled) {
                const {authTokens} = authTokenReducer
                config.headers.authorization = 'Bearer ' + authTokens.accessToken
            }
        }

        // Subdomain is switching from 'apps' to 'jobs' and 'jobs-api'
        // Temporary redirecting while both versions are still active
        const host = window.location.hostname.split('.')
        if (host[0] == 'jobs') {
            config.baseURL = `https://jobs-api.${host[1]}.${host[2]}`
        }

        return config
    })

    return axiosInstance
}

export default createAxiosAuthInterceptor()
